import { render, staticRenderFns } from "./driverRecruitRewardList.vue?vue&type=template&id=81af7128&scoped=true&"
import script from "./driverRecruitRewardList.vue?vue&type=script&lang=js&"
export * from "./driverRecruitRewardList.vue?vue&type=script&lang=js&"
import style0 from "./driverRecruitRewardList.vue?vue&type=style&index=0&id=81af7128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af7128",
  null
  
)

export default component.exports